import styles from './RelevantHistorySection.module.css';

interface RelevantHistorySectionProps {
  indication?: string | null;
  cardiacHistory?: string | null;
}

export default function RelevantHistorySection({
  indication,
  cardiacHistory,
}: RelevantHistorySectionProps) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>Relevant History</h3>
      <div className={styles.row}>
        <div className={styles.kv}>
          <span className={styles.kvLabel}>Indication:</span>
          <span className={styles.kvValue}>{indication || '—'}</span>
        </div>
        <div className={styles.kv}>
          <span className={styles.kvLabel}>Cardiac History:</span>
          <span className={styles.kvValue}>{cardiacHistory || '—'}</span>
        </div>
      </div>
    </section>
  );
}
